export const handleContextMenu = (event) => {
    event.preventDefault();
  };